define('shared/util/adyen/rejectPayment',[
    'Promise'
], function (
    Promise
) {
    var REJECTED = 'rejected';
    return function () {
        var err = new Error('Payment rejected');
        err.fatal = false;
        err.type = REJECTED;
        return Promise.reject(err);
    };
});
